module.exports = __webpack_public_path__ + "static/media/golf-club.10390614.svg";